import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleTopic } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheTopicComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const topicCombo = computed(() => {
    const topics = store.getters[`${ModuleTopic}/items`];
    return topics.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheTopicComboConfig = reactive({
    data: topicCombo,
    columns: [
      {
        title: 'Mã đề tài',
        dataField: 'topic_code',
        width: 160,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đề tài',
        dataField: 'topic_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 440,
      },
    ],
    quickAdd: 'TopicDetail',
    displayField: 'topic_code',
    valueField: 'topic_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    forceReload: true,
    quickSearchParam: {
      idField: 'topic_id',
      titleSearch: 'Tìm nhanh đề tài',
    },
  });
  return {
    cacheTopicComboConfig,
  };
};
